var constants = require('../constants');

var AppDownloadClick = (function() {

    var _recordDownloadClick = function(action, label) {
      return {
        type: constants.APP_DOWNLOAD_CLICK,
        meta: {
            analytics: {
                eventType: constants.APP_DOWNLOAD_CLICK,
                actionValue: action,
                labelValue: label
            }
        }
      };
    }

    return {
        recordDownloadClick: _recordDownloadClick
    }
})();

module.exports = AppDownloadClick;


// WEBPACK FOOTER //
// ./src/common/modules/meta/actions/appDownload-click.js